export const USER_INFO_REQUEST = 'USER_INFO_REQUEST';
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export const USER_INFO_FAILURE = 'USER_INFO_FAILURE';
export const GET_INITIAL_DATA_REQUEST = 'GET_INITIAL_DATA_REQUEST';
export const GET_INITIAL_DATA_REQUEST_SUCCESS = 'GET_INITIAL_DATA_REQUEST_SUCCESS';



// WEBPACK FOOTER //
// ./src/modules/App/redux/constants/user_info.constants.js